import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypeSliderModule} from './../type-slider/type-slider.module';
import {TypeMultiSliderComponent} from './type-multi-slider.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TypeSliderModule,
  ],
  declarations: [
    TypeMultiSliderComponent,
  ],
  exports: [
    TypeMultiSliderComponent,
  ],
})
export class TypeMultiSliderModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-multi-slider/type-multi-slider.module.ts